module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "worker small-text"
  }, [(_vm.language === "nl") ? _c('div', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.item.title))]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.item.title_en))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "secondary-color strong"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.item["email_address"]
    }
  }, [_vm._v(_vm._s(_vm.item['email_address']))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item['phone_number']))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e6d78ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsTeamItem.vue
// module id = 219
// module chunks = 2